import React from 'react';

export default function useImage(url) {
  const [src, setSrc] = React.useState(null);
  React.useLayoutEffect(() => {
    if (!url) return;
    if (typeof url === 'string') {
      const image = new Image();
      image.onload = () => {
        setSrc(() => url);
        delete image.onload;
        delete image.onerror;
      };
      image.onerror = () => {
        setSrc(() => null);
        delete image.onload;
        delete image.onerror;
      };
      image.src = url;
    }
    return () => setSrc(() => null);
  }, [url]);
  return src;
}
